import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-receipt',
  templateUrl: './order-receipt.component.html',
  styleUrls: ['./order-receipt.component.css']
})
export class OrderReceiptComponent implements OnInit {

  displayedColumns: string[] = ['nombre', 'precio', 'cantidad', 'total'];
  dataSource = ELEMENT_DATA;

  constructor() { }

  ngOnInit(): void {
  }

}
export interface DetailOrder{
  nombre: string;
  precio: any;
  cantidad: any;
  total: any;

}
const ELEMENT_DATA: DetailOrder[] = [
  { nombre: 'Burger', precio: 7.99, cantidad: 1, total: 7.99},
  { nombre: '', precio: '', cantidad: 'Total', total: 7.99},
  { nombre: '', precio: '', cantidad: 'Cargos de envío', total: 2.75},
  { nombre: '', precio: '', cantidad: 'Subtotal', total: 10.74},

  
];